var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"20px"}},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"search-options":{
      enabled: false,
      placeholder: 'Search Cashback Rates',
    },"pagination-options":{
      enabled: true,
      perPage: 20
    }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'txid')?_c('span',[_c('a',{attrs:{"href":props.row.txid,"target":"_blank"}},[_vm._v("txid link")])]):_c('span',[_vm._v("\n        "+_vm._s(props.formattedRow[props.column.field])+"\n      ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }